import React from 'react';
import { assetsPath } from "../../utils";

const bgImg = 'https://lagunaproperty.com/images/2008_photo.jpg';

const logoImg = `${assetsPath()}/images/logo-laguna-property.svg`;

const data = {
  en: (
    <div>
      <h2>Developer</h2>
      <p>
        The company has since established itself as the largest and most established property developer in Phuket (Thailand), Bintan (Indonesia) and
        Lăng Cô (Vietnam).
      </p>
      <p>
        With over 1,200 properties, Laguna Property offers a wide range of residential and investment properties, condos, townhouses, villas, and
        residences.
      </p>
      <p>
        Laguna Resorts &amp; Hotels PLC. listed on the Stock Exchange of Thailand in 1993 and has gained a strong reputation as a responsible
        developer whose interests combine hotels and real estate with an emphasis on quality and environmental protection, having received numerous
        environmental and tourism awards.
      </p>
    </div>
  ),
  ru: <div />,
  cn: <div />
};

export { data, bgImg, logoImg };


// WEBPACK FOOTER //
// ./src/data/AboutUs/developer.js